import { api } from "./client";

export const ORDER_STATUSES = [
  { value: "quoted",      label: "Quoted" },
  { value: "confirmed",   label: "Confirmed" },
  { value: "in_progress", label: "In progress" },
  { value: "delivered",   label: "Delivered" },
  { value: "cancelled",   label: "Cancelled" },
];

export const toAmount = (value) => {
  const n = Number(String(value ?? "").replace(/[^\d.]/g, ""));
  return Number.isFinite(n) ? n : 0;
};

export const formatINR = (value) =>
  "₹" + Math.round(toAmount(value)).toLocaleString("en-IN");

export const emptyItem = { key: "custom", type: "Custom", name: "", listPrice: 0, price: 0 };

export function computeTotals(items, advance) {
  const listTotal = items.reduce((sum, it) => sum + toAmount(it.listPrice), 0);
  const total     = items.reduce((sum, it) => sum + toAmount(it.price), 0);
  const paid      = toAmount(advance);
  return {
    listTotal,
    total,
    discount: Math.max(0, listTotal - total),
    advance:  paid,
    due:      Math.max(0, total - paid),
  };
}

const today = () => new Date().toISOString().slice(0, 10);

export const emptyOrder = {
  clientId:  "",
  orderDate: today(),
  status:    "quoted",
  items:     [{ ...emptyItem }],
  advance:   0,
  notes:     "",
};

function normalise(order, client) {
  const items = (order.items || [])
    .filter((it) => String(it.name || "").trim())
    .map((it) => ({
      key:       it.key || "custom",
      type:      it.type || "Custom",
      name:      String(it.name).trim(),
      listPrice: toAmount(it.listPrice),
      price:     toAmount(it.price),
    }));
  const totals = computeTotals(items, order.advance);
  return {
    clientId:  order.clientId || "",
    client: client
      ? {
          name:         client.name || "",
          businessName: client.businessName || "",
          phone:        client.phone || "",
          email:        client.email || "",
          address:      client.address || "",
        }
      : order.client || {},
    orderDate: order.orderDate || today(),
    status:    order.status || "quoted",
    items,
    ...totals,
    notes: String(order.notes || "").trim(),
  };
}

export async function getOrders() {
  const { orders } = await api.get("/orders", { auth: true });
  return orders;
}

export async function createOrder(order, client) {
  const payload     = normalise(order, client);
  const { order: saved } = await api.post("/orders", payload, { auth: true });
  return saved;
}

export async function updateOrder(id, order, client) {
  const payload = normalise(order, client);
  await api.put(`/orders/${id}`, payload, { auth: true });
  return payload;
}

export async function deleteOrder(id) {
  await api.del(`/orders/${id}`, { auth: true });
}
